<script setup>
import { onMounted, ref } from 'vue'
import { get_user_roles, userCollection, destroyUser } from '@/services/user'
import { swalError } from '@/helper';

const permissions = ref([
  {
    name: 'super administrator',
    permission: [
      'User can create, update and delete interventions',
      'User can create, update and delete assessments',
      'User can create, update and delete children',
      'User can create, update and delete children reports',
      'User can create, update and delete children reports',
      'User can create, update and delete user',
      'Approve, manage and monitor all WebApps users and content.',
      'Handle subscription and payment systems.',
      'Ensure the information on User\'s Dashboard is up-to-date and accurate.',
      'Manage and monitor user-generated content in adherence to community guidelines.',
      'Handle complaints or requests for refunds, subscription changes, etc.',
      'Respond to inquiries or help requested by users related to the Webapps Functions. ',
      'Prepare Monthly Dashboard\'s data analysis reports ',
      'Restore any relevant user account if requested.',
    ]
  },
  {
    name: 'Module Admin',
    permission: [
      'Collaborate with professionals to create educational content for parents. ',
      'Input the content for each module ',
      'Curate personalized assessment, activities, reading materials and references.',
      'Improve the modules based on the feedbacks from Parents/Teachers',
    ]
  },
  {
    name: 'Forum Admin',
    permission: [
      'Approve Moderators and Monitor all forums for inappropriate content or behaviours.',
      'Respond to flagged posts, questions, and discussions.',
      'Help resolve disputes between users if necessary.',
      'Encourage engagement by starting or contributing to discussions. ',
      'Generating appropriate and engaging contents in the forum ',
      'Badges and User Levels allocation for suitable users.',
    ]
  },
  {
    name: 'Professional Advisor',
    permission: [
      'Answer specific questions posed by parents.',
      'Involve in webinars or live Q&A sessions. ',
      'Provide professional insights for personalized activities based on child genetic profiles.',
      'Provide specific personalized guidance and advices for parents in need.',
    ]
  },
  {
    name: 'Developer',
    permission: [
      'Maintain the functionality and performance of the web app.',
      'Implement new features, updates, and bug fixes.',
      'Ensure mobile responsiveness and compatibility.',
      'Work closely with the administrator to enhance user experience.',
      'Respond to technical or usage queries from parents.',
      'Offer troubleshooting help, such as logging-in issues, billing, or activity navigation.',
      'Identify trends and make data-driven suggestions for improving the app\'s content and features.',
      'Mobile responsiveness & compatibility ',
    ]
  },
])
const roles = ref([])
const isLoading = ref(true)
onMounted(async ()=>{
  await retrieve_role()
  isLoading.value = false
})

async function retrieve_role(){
  let response = await get_user_roles()
  console.log("🚀 ~ retrieve_role ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  roles.value = response.result.data
}
</script>

<template>
  <Breadcrumbs main="User Roles"/>
  <div class="container-fluid text-start">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5>Permissions</h5>
            <div class="row">
              <div class="col-12 p-2"  v-for="permission in permissions">
                <div class="card no-shadow border mb-2">
                  <div class="card-body">
                    <h6>
                      <span class="text-secondary">Role Name : </span>
                      <span class="text-capitalize">{{ permission.name }}</span>
                    </h6>
                    <ol class="list-group list-group-numbered">
                      <li v-for="item in permission.permission" class="d-block" for="chk-ani">
                        - {{ item }}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>